import type { ComponentPropsWithoutRef } from "react";
import { type DropzoneOptions, useDropzone } from "react-dropzone-esm";
import { classNames } from "../../utils/classNames";

export interface IDropzoneProps extends ComponentPropsWithoutRef<"input"> {
  options?: DropzoneOptions;
}

export function Dropzone({
  children,
  className,
  options = {},
  style,
  ...props
}: IDropzoneProps) {
  const { getRootProps, getInputProps, isDragActive, isDragAccept } =
    useDropzone(options);

  return (
    <div
      {...getRootProps()}
      data-slot="control"
      className={classNames(
        "group relative overflow-hidden border border-primary rounded-xl p-4 flex items-center flex-col gap-1 justify-center transition-colors",
        {
          "hover:border-info border-dashed": !options.disabled,
          "border-info bg-info/20":
            isDragActive && isDragAccept && !options.disabled,
          "border-tertiary": options.disabled,
        },
        className,
      )}
      style={style}
    >
      <input {...props} {...getInputProps()} />
      {children}
    </div>
  );
}
